/** Текущее соединение со шлюзом — для компонентов, которым нужно отправлять опкоды (op 14). */
import type { GatewayClient } from './gateway'

let current: GatewayClient | null = null

export const setGatewayClient = (client: GatewayClient | null): void => {
  current = client
}

export const gatewayClient = (): GatewayClient | null => current
